import { useMutation } from '@tanstack/react-query';

import { saveEmailTemplate } from '../api';

export const useSaveEmailTemplate = () => {
  return useMutation({
    mutationFn: saveEmailTemplate,
    onSuccess: (_data) => {},
    onError: (_error) => {},
  });
};
